import { render, staticRenderFns } from "./PackageUpdateStatusModal.vue?vue&type=template&id=2e7a48f3&"
import script from "./PackageUpdateStatusModal.vue?vue&type=script&lang=js&"
export * from "./PackageUpdateStatusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports